import React from 'react';
import styles from './ContactBanner.module.css';

const ContactBanner = () => (
  <section 
    className={styles.banner}
    style={{ backgroundImage: "url('/Assets/Images/Contactus/contactus.svg')" }}
    aria-label="Contact Us Banner"
  >
    <div className={styles.content}>
      <h2 className={styles.heading}>Contact Us</h2>
      
      <div className={styles.dots} aria-hidden="true">
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
      
      <p className={styles.subtext}>
        Whether you're curious or ready to deploy drones, we're here to help.
        Drop us your details, and we'll connect with you.
      </p>
    </div>
  </section>
);

export default ContactBanner;